module.exports = __webpack_public_path__ + "static/media/linkedin.d8144cf2.svg";